import { createCrudActions } from "../utils/crudGenerator";

const formatIrregularitytypes = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.name}`,
		value: item._id,
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

export const {
	fetch: fetchIrregularitytypes,
	create: createIrregularitytype,
	update: updateIrregularitytype,
	delete: deleteIrregularitytypes,
} = createCrudActions("IRREGULARITYTYPE", "Tipo de irregularidad", formatIrregularitytypes);
